(function () {
  const runEuroFormatter = () => {
    const isIreland = window.Shopify && Shopify.country === 'IE';
    if (!isIreland) return;

    console.log('[EuroFormat] Formatter running');

    const priceSelectors = [
      '.spf-product-card__price',
      '.price-item',
      '.money'
    ];

    const formattedSet = new WeakSet(); // prevent repeat formatting

    priceSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        const text = el.textContent.trim();

        // Skip if already formatted or contains dot decimal
        if (formattedSet.has(el) || (text.includes('.') && !text.includes(','))) return;

        if (text.includes(',')) {
          const cleaned = text.replace(/\./g, '').replace(',', '.');
          el.textContent = cleaned;
          formattedSet.add(el);
          console.log(`[EuroFormat] Converted: ${text} → ${cleaned}`);
        }
      });
    });
  };

  const observeMutations = () => {
    const observer = new MutationObserver(() => {
      runEuroFormatter();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  // Initial run
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[EuroFormat] Script loaded');
    runEuroFormatter();
    observeMutations();
  });

  // Re-run after InstantPage navigation (if used)
  document.addEventListener('instantpage:change', runEuroFormatter);

  // Re-run after Shopify section loads or variant switches
  document.addEventListener('shopify:section:load', runEuroFormatter);
  document.addEventListener('shopify:section:select', runEuroFormatter);
  document.addEventListener('variant:change', () => setTimeout(runEuroFormatter, 50));
})();
